import React from 'react';

import { Button } from 'antd';
import ReactResizeDetector from 'react-resize-detector';
import Calendar from '../../../assets/calendar.png';
import ImgGlobe from '../../../assets/globe.png';
import PageHeader from '../page-header';
import FilterBar from './nav-section-mobile';
import { CheckboxValueType } from 'antd/lib/checkbox/Group';

interface IHeaderSectionProps {
  settings: any;
  scrollTo: (sectionName: any) => void;
  onCheckedListChange?: (checkedList: CheckboxValueType[]) => void;
}

const HeaderSection: React.FunctionComponent<IHeaderSectionProps> = ({
  settings,
  scrollTo,
  onCheckedListChange,
}) => (
  <div className="header-section-bg">
    <ReactResizeDetector>
      <div className="header-section">
        <div className="fixed-element">
          <PageHeader noHomeButton={true} />
          <FilterBar
            settings={settings}
            onCheckedListChange={onCheckedListChange}
          />
        </div>

        <div className="branding-section-container">
          <div className="branding-section">
            <div className="branding-text-content">
              <div className="branding-text">
                <div className="l2">
                  <div className="red">{settings?.header1}</div>
                  <div className="blue">{settings?.header2}</div>
                </div>
              </div>
              <div className="branding-description">
                <p
                  dangerouslySetInnerHTML={{
                    __html: settings?.overview1,
                  }}
                />
                <p
                  dangerouslySetInnerHTML={{
                    __html: settings?.overview2,
                  }}
                />
                <p
                  dangerouslySetInnerHTML={{
                    __html: settings?.overview3,
                  }}
                />
              </div>
            </div>
            <div className="branding-section-img-con">
              <img className="mobile-view" width="100%" src={ImgGlobe} alt="" />
              <div className="brand-float c1">
                <div className="brand-float-container">
                  <div className="brand-float-text">{settings?.floatText1}</div>
                  <Button
                    onClick={() => scrollTo('course')}
                    className="join-btn"
                    shape="round"
                    size="small"
                  >
                    {settings?.join}
                  </Button>
                </div>
              </div>
              <div className="brand-float c2">
                <div className="brand-float-container ">
                  <div className="brand-float-title">
                    {settings?.floatText2About}
                  </div>
                  <div className="brand-float-text">{settings?.floatText2}</div>
                  <Button
                    onClick={() => scrollTo('about')}
                    className="download-btn"
                    shape="round"
                    size="small"
                  >
                    {settings?.learnMore}
                  </Button>
                </div>
              </div>
              <div className="brand-float c3">
                <div className="brand-float-container ">
                  <div className="brand-float-icon">
                    <img src={Calendar} alt="" />
                  </div>
                  <div
                    onClick={() => scrollTo('intro')}
                    className="brand-float-text"
                  >
                    {settings?.floatText3}
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </ReactResizeDetector>
  </div>
);

export default HeaderSection;
